import { render, staticRenderFns } from "./expertFeeArguForm.vue?vue&type=template&id=a6dcb9ee&scoped=true"
import script from "./expertFeeArguForm.vue?vue&type=script&lang=js"
export * from "./expertFeeArguForm.vue?vue&type=script&lang=js"
import style0 from "./expertFeeArguForm.vue?vue&type=style&index=0&id=a6dcb9ee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dcb9ee",
  null
  
)

export default component.exports